import { Radar } from "lucide-react";

export const ScanningBay = ({ status, lastScan }) => {
  const busy = status === "scanning";
  const error = status === "unknown";
  return (
    <section
      data-testid="kiosk-scanning-bay"
      className={`scan-bay relative flex min-h-[360px] flex-col items-center justify-center overflow-hidden p-8 ${error ? "scan-bay-error" : ""}`}
    >
      <div className="absolute inset-0 lab-grid opacity-40" />
      {busy && <div className="scan-beam" />}
      <div className="relative flex h-56 w-56 items-center justify-center">
        <span className="pulse-ring" />
        <span className="pulse-ring" style={{ animationDelay: "0.8s" }} />
        <span className="pulse-ring" style={{ animationDelay: "1.6s" }} />
        <div className={`relative z-10 flex h-28 w-28 items-center justify-center rounded-full border ${error ? "border-rose-400 text-rose-400" : "border-cyan-300/70 text-cyan-300"} bg-slate-950/80`}>
          <Radar size={48} className={busy ? "animate-spin" : ""} />
        </div>
      </div>
      <div className="relative z-10 mt-6 text-center">
        <p data-testid="scan-bay-status" className={`font-mono text-sm uppercase tracking-[0.3em] ${error ? "text-rose-400" : "text-cyan-300"}`}>
          {busy ? "Signal sent // retrieving memory" : error ? "The hive holds nothing for this" : "The hive is holding something"}
        </p>
        <p className="mt-3 max-w-sm text-base text-slate-300">
          {error
            ? `No memory is attached to object ${lastScan}. Offer it something else.`
            : "Place an object on the sensor pad to recover the memory it holds. Gently, mind."}
        </p>
      </div>
    </section>
  );
};
